import { render, staticRenderFns } from "./SubHeaderCreate.vue?vue&type=template&id=1dfc3598&"
import script from "./SubHeaderCreate.vue?vue&type=script&lang=js&"
export * from "./SubHeaderCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports